import React from 'react'

const SectionLabel = ({ heading, body, styles }) => {
  return (
    <section className={styles}>
      <div className="">
        <h2 className="text-3xl font-extrabold condensed">{heading}</h2>
        <p className="text-xl pt-2 font-semibold">{body}</p>
      </div>
    </section>
  )
}

export default SectionLabel
